import React from "react";

export default function UnableEdit() {
    // 変更不可の表示をコンポーネント化
    return <span className='text-danger fw-normal'>変更不可</span>;
}
